import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-automation" },
    [
      _c(
        VAlert,
        {
          staticClass: "mb-4",
          attrs: { type: "info", outlined: "", dense: "" },
        },
        [_vm._v(" " + _vm._s(_vm.$t("create_attribute.share_info")) + " ")]
      ),
      _c(
        VForm,
        { ref: "form", staticClass: "mb-4" },
        [
          _c(
            VRow,
            { attrs: { dense: "", align: "center" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12", sm: "9" } },
                [
                  _c(VCombobox, {
                    attrs: {
                      multiple: "",
                      dense: "",
                      outlined: "",
                      label: _vm.$t("attributes.label.users"),
                      placeholder: _vm.$t("attributes.placeholder.input_user"),
                      rules: [_vm.ruleEmailMultiSelect],
                      chips: "",
                      "append-icon": "",
                      "error-messages": _vm.errors,
                      "hide-details": "auto",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function (ref) {
                          var chip = ref.item
                          var attrs = ref.attrs
                          var selected = ref.selected
                          var disabled = ref.disabled
                          var parent = ref.parent
                          return [
                            _c(
                              VChip,
                              _vm._b(
                                {
                                  key: JSON.stringify(chip),
                                  attrs: {
                                    "input-value": selected,
                                    disabled: disabled,
                                    close: "",
                                    dark: "",
                                  },
                                  on: {
                                    "click:close": function ($event) {
                                      return parent.selectItem(chip)
                                    },
                                  },
                                },
                                "v-chip",
                                attrs,
                                false
                              ),
                              [_vm._v(" " + _vm._s(chip) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.newUsers,
                      callback: function ($$v) {
                        _vm.newUsers = $$v
                      },
                      expression: "newUsers",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        block: "",
                        color: "primary",
                        loading: _vm.isSaving,
                        disabled: _vm.isSaving || !_vm.newUsers.length,
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.add")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isLoadingUsers
        ? [
            _c(VSkeletonLoader, {
              staticClass: "mb-1",
              attrs: { type: "list-item-avatar" },
            }),
            _c(VSkeletonLoader, { attrs: { type: "list-item-avatar" } }),
          ]
        : [
            _vm.sharedUsers.length === 0
              ? _c(
                  "div",
                  { staticClass: "text-center py-6" },
                  [
                    _c(
                      VIcon,
                      { attrs: { large: "", color: "grey lighten-1" } },
                      [_vm._v("mdi-account-group-outline")]
                    ),
                    _c("p", { staticClass: "mt-2 mb-0 grey--text" }, [
                      _vm._v(_vm._s(_vm.$t("create_attribute.share_empty"))),
                    ]),
                  ],
                  1
                )
              : _c(
                  VList,
                  {
                    staticClass: "py-0 elevation-1 rounded",
                    attrs: { dense: "" },
                  },
                  [
                    _c(
                      VListItem,
                      [
                        _c(
                          VListItemAvatar,
                          {
                            staticClass: "justify-center",
                            attrs: { size: "32", color: "primary" },
                          },
                          [
                            _c("span", { staticClass: "white--text caption" }, [
                              _vm._v(_vm._s(_vm.initials(_vm.item.owner_name))),
                            ]),
                          ]
                        ),
                        _c(
                          VListItemContent,
                          [
                            _c(VListItemTitle, [
                              _vm._v(_vm._s(_vm.item.owner_name)),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          VListItemAction,
                          [
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: { icon: "", small: "" },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "amber darken-2",
                                                },
                                              },
                                              [_vm._v("mdi-crown")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("frases.attrs_sandbox_owner"))
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(VDivider),
                    _vm._l(_vm.sharedUsers, function (user, index) {
                      return [
                        _c(
                          VListItem,
                          { key: user.email },
                          [
                            _c(
                              VListItemAvatar,
                              {
                                staticClass: "justify-center",
                                attrs: {
                                  size: "32",
                                  color: "blue-grey lighten-2",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "white--text caption" },
                                  [_vm._v(_vm._s(_vm.initials(user.email)))]
                                ),
                              ]
                            ),
                            _c(
                              VListItemContent,
                              [
                                _c(VListItemTitle, [
                                  _vm._v(_vm._s(user.email)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VListItemAction,
                              [
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmRevoke(
                                                            user
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "error",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-minus-circle-outline"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("frases.delete_user"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        index < _vm.sharedUsers.length - 1
                          ? _c(VDivider, { key: "divider-" + index })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
          ],
      _c(
        VDialog,
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.revokeDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.revokeDialog, "show", $$v)
            },
            expression: "revokeDialog.show",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "text-h6" }, [
                _vm._v(" " + _vm._s(_vm.$t("frases.delete_user")) + " "),
              ]),
              _c(VCardText, [
                _vm._v(" " + _vm._s(_vm.revokeConfirmText) + " "),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.revokeDialog.show = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btns.cancel")) + " ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        loading: _vm.isRevoking,
                      },
                      on: { click: _vm.executeRevoke },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btns.confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }